<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { isActionVisible } from "@/components/StickyNote/internal/ActionMenu/actions";
import { boardKey } from "@/components/board/injectKeys";
import { injectStrict } from "@/utils/vue";

import ChangeArt from "./ChangeArt.vue";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);
</script>

<template>
  <ActionMenuDropdown v-if="isActionVisible('art', card, board)" :action="cardActions.setArt">
    <ChangeArt />
  </ActionMenuDropdown>
</template>
